import React, { useState } from 'react';
import { Button, Card, Table } from 'reactstrap';
import Layout from '../components/Layout';
import style from '../styles/layout.module.css';
import axios from 'axios';

const UploadExcelBarcode = () => {
  const [file, setFile] = useState(null);
  const [items, setItems] = useState([]);
  const [message, setMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false); // 上傳狀態

  // 處理檔案選取
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage('');
    setItems([]); // 選新檔時清空資料
  };

  // 處理Excel上傳與結果
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('請選擇一個檔案');
      return;
    }

    setIsUploading(true); // 進入上傳中
    setMessage('');

    const formData = new FormData();
    formData.append('file', file);

    const apiUrl = process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/api/v1/Backend/ShipperMt/UploadExcelBarcode`
      : '/api/v1/Backend/ShipperMt/UploadExcelBarcode';

    try {
      const res = await axios.post(apiUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      let data = [];
      if (Array.isArray(res.data)) {
        data = res.data;
      } else if (res.data && Array.isArray(res.data.items)) {
        data = res.data.items;
      } else if (res.data && res.data.message) {
        setMessage(res.data.message);
        setItems([]);
        setIsUploading(false);
        return;
      } else {
        setMessage('API 回傳格式不正確');
        setItems([]);
        setIsUploading(false);
        return;
      }

      setItems(data);

      // 判斷資料是否全部正確（Status都不是Error）
      if (data.length > 0 && data.every(item => item.status !== 'Error')) {
        setMessage('✅ 全部資料正確，無錯誤！');
      } else if (data.length === 0) {
        setMessage('✅ 全部資料正確，無錯誤！');
      } else {
        setMessage('');
      }

    } catch (error) {
      setMessage(error?.response?.data?.message || '上傳失敗');
      setItems([]);
    } finally {
      setIsUploading(false); // 上傳結束
    }
  };

  return (
    <Layout
      pageTitle="匯入 Excel (國際條碼)"
      items={[
        { isActive: false, page_name: '序號/綁定及出貨' },
        { isActive: true, page_name: '匯入 Excel (國際條碼)' },
      ]}
    >
      <Card className={style.card}>
        <div className={style.card_header}>Excel 上傳 (國際條碼 + 商品序號 + 保固序號)</div>
        <div className={style.card_body}>
          <form onSubmit={handleUpload}>
            <div className={style.formGroup}>
              <label htmlFor="file" className="form-label">選擇 Excel 檔案：</label>
              <input
                type="file"
                id="file"
                name="file"
                accept=".xlsx,.xls"
                className="form-control"
                onChange={handleFileChange}
                disabled={isUploading}
              />
            </div>
            <div className="mt-3">
              <Button
                type="submit"
                className="btn btn-primary"
                disabled={isUploading}
              >
                {isUploading ? '上傳中...' : '上傳'}
              </Button>
            </div>
          </form>

          {message && <div className="mt-3 text-success">{message}</div>}

          {items.length > 0 && (
            <div className="mt-4">
              <Table bordered striped>
                <thead>
                  <tr>
                    <th>Row</th>
                    <th>通路</th>
                    <th>出倉日</th>
                    <th>國際條碼</th>
                    <th>保固序號</th>
                    <th>產品序號</th>
                    <th>出貨狀態</th>
                    <th>訊息</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, idx) => (
                    <tr key={item.rowIndex || idx}>
                      <td>{item.rowIndex}</td>
                      <td>{item.supplier}</td>
                      <td>{item.time}</td>
                      <td>{item.barcode}</td>
                      <td>{item.warrantySerialNum}</td>
                      <td>{item.serialNumber}</td>
                      <td style={{ color: item.status === 'Error' ? 'red' : 'green' }}>
                        {item.status}
                      </td>
                      <td>{item.message}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </Card>
    </Layout>
  );
};

export default UploadExcelBarcode;
